import { VERSION as d } from "./index58.js";
import a from "./index60.js";
const u = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((n, e) => {
  u[n] = function(o) {
    return typeof o === n || "a" + (e < 1 ? "n " : " ") + n;
  };
});
const f = {};
u.transitional = function(e, i, o) {
  function l(t, r) {
    return "[Axios v" + d + "] Transitional option '" + t + "'" + r + (o ? ". " + o : "");
  }
  return (t, r, s) => {
    if (e === !1)
      throw new a(
        l(r, " has been removed" + (i ? " in " + i : "")),
        a.ERR_DEPRECATED
      );
    return i && !f[r] && (f[r] = !0, console.warn(
      l(
        r,
        " has been deprecated since v" + i + " and will be removed in the near future"
      )
    )), e ? e(t, r, s) : !0;
  };
};
u.spelling = function(e) {
  return (i, o) => (console.warn(`${o} is likely a misspelling of ${e}`), !0);
};
function w(n, e, i) {
  if (typeof n != "object" || n === null)
    throw new a("options must be an object", a.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(n);
  let l = o.length;
  for (; l-- > 0; ) {
    const t = o[l], r = Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
    if (r) {
      const s = n[t], c = s === void 0 || r(s, t, n);
      if (c !== !0)
        throw new a(
          "option " + t + " must be " + c,
          a.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (i !== !0)
      throw new a("Unknown option " + t, a.ERR_BAD_OPTION);
  }
}
const O = {
  assertOptions: w,
  validators: u
};
export {
  O as default
};
